/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PagedModelSiteSortimentEntryResponseModel } from '../../models/paged-model-site-sortiment-entry-response-model';

export interface GetSortimentEntries$Params {

/**
 * UUID of the merchant site to list sortiment entries for
 */
  siteId: string;
}

export function getSortimentEntries(http: HttpClient, rootUrl: string, params: GetSortimentEntries$Params, context?: HttpContext): Observable<StrictHttpResponse<PagedModelSiteSortimentEntryResponseModel>> {
  const rb = new RequestBuilder(rootUrl, getSortimentEntries.PATH, 'get');
  if (params) {
    rb.path('siteId', params.siteId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PagedModelSiteSortimentEntryResponseModel>;
    })
  );
}

getSortimentEntries.PATH = '/site/{siteId}/products';
